import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { MatInputModule } from '@angular/material/input';
import { MaskDirective } from './mask.directive';
import { InvalidFormScrollDirective } from './invalid-form-scroll.directive';
import { DrawerHostDirective } from './drawer-host.directive';
import { TrackClickDirective } from '@app/directives/track-click.directive';
import { DownloadPopoverOptionsDirective } from './download-popover-options.directive';

const directives = [
	MaskDirective,
	InvalidFormScrollDirective,
	DrawerHostDirective,
	TrackClickDirective,
	DownloadPopoverOptionsDirective
];

@NgModule({
	imports: [CommonModule, MatInputModule],
	declarations: directives,
	exports: directives
})
export class SharedDirectivesModule {}
